
import CustomText from '../../atomic/atoms/custom-text.atom';
import CustomButton from '../../atomic/atoms/custom-button.atom';
import { ArrowForward } from '@material-ui/icons';
import { FaDollarSign } from 'react-icons/fa';
import InfoBox from '../../atomic/molecules/info-box.molecule';
import { FaGift, FaRegFaceSmile, FaStar } from 'react-icons/fa6';
import NavBar from '../../atomic/organism/nav-bar.organism';
import PropTypes from "prop-types";
import { Box, makeStyles, Link } from '@material-ui/core';
import FitoImage from '../molecules/fito-image.molecule';
import { useDynamicLink } from '../../hooks/useDynamicLink';

const useStyles = makeStyles((theme) => ({
    primaryAction: {
        marginRight: theme.spacing(2),
        [theme.breakpoints.down("xs")]: {
            width: "100%",
            marginRight: theme.spacing(0),
            marginBottom: theme.spacing(2),
        },
    },
    logo: {
        height: 40,
        width: '100%',
    },
}));

const ReferrerLandingTemplate = ({
    referralDiscount = 25,
    onStartRequest = () => {},
}) => {
    const classes = useStyles();
    const downloadAppDynamicLink = useDynamicLink();

    return (
        <>
            <div style={styles.container}>
                <NavBar />
                <section style={styles.hero}>
                    <CustomText variant="headline4xl" style={styles.heroTitle}>Has sido invitado a <span style={styles.belozText}>Beloz<span style={styles.fiText}>fi</span></span></CustomText>
                    <CustomText variant="subtitle" style={styles.heroSubtitle}>Préstamos digitales, rápidos, seguros y con 0% de interés en minutos</CustomText>
                </section>

                <section style={{...styles.section, position: 'relative'}}>
                    <FitoImage emotion={'surprised'} style={{width: '66px', height: '66px', position: 'absolute', top: '-33px', right: '0'}}/>
                    <div style={{ ...styles.section, gap: '24px', padding: '0px' }}>
                        <CustomText style={styles.heroText}>Solicita tu préstamo aquí y...</CustomText>
                        <CustomText variant='headline2xl' style={styles.heroText}>¡Obtén ${referralDiscount} MXN de descuento en tu primer préstamo!</CustomText>
                    </div>
                    <CustomButton right={() => <ArrowForward style={{ color: '#fff' }} />} onClick={onStartRequest}>Comenzar solicitud</CustomButton>
                </section>
            </div>
            <div style={{ ...styles.container, backgroundColor: '#F2F2F2' }}>
                <section style={styles.subSection}>
                    <CustomText variant='headlineXl' style={styles.subSectionText}>¿Por qué Belozfi?</CustomText>
                    <div>
                        <CustomText variant='headline3xl' style={styles.subSectionText}>125,000+</CustomText>
                        <CustomText variant='bodySmall' style={styles.subSectionText}>Préstamos otorgados</CustomText>
                    </div>
                </section>
                <section style={styles.subSection}>
                    <InfoBox icon={() => (
                        <div style={styles.iconWrapper}>
                            <FaDollarSign style={styles.icon} />
                        </div>
                    )}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                            <CustomText variant='bodySmall'> <CustomText variant='subtitleSmall' span>Recibe tu dinero hoy mismo</CustomText> si completas todos los pasos</CustomText>
                        </div>
                    </InfoBox>
                    <InfoBox icon={() => (
                            <FaRegFaceSmile style={{...styles.icon, width: '24px', height: '24px'}} />
                    )}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                            <CustomText variant='bodySmall'><CustomText variant='subtitleSmall' span>Sin presiones,</CustomText> sin cobranzas invasivas</CustomText>
                        </div>
                    </InfoBox>
                    <InfoBox icon={() => (
                            <FaGift style={{...styles.icon, width: '24px', height: '24px'}}/>
                    )}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                            <CustomText variant='bodySmall'><CustomText variant='subtitleSmall' span>Descuentos y bonificaciones</CustomText> para que pagues menos</CustomText>
                        </div>
                    </InfoBox>
                </section>
                <section style={styles.subSection}>
                    <div style={{display: 'flex', paddingTop: '20px', paddingBottom: '20px', justifyContent: 'space-between'}}>
                        <div style={{width: '50%'}}>
                            <Box display="flex" flexDirection={'row'} flexWrap="wrap" justifyContent="center" style={{gap: '16px'}}>
                                <Box pt={4} display="flex" flexDirection={'column'} flexWrap="wrap" justifyContent="center">
                                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', gap: '16px'}}> 
                                        <CustomText variant='subtitle' style={{textAlign: 'center'}}>
                                            4.8
                                        </CustomText>
                                        <FaStar/>
                                    </div>
                                    <CustomText variant='bodySmall' style={{textAlign: 'center'}}>
                                        17.6 K opiniones
                                    </CustomText>
                                </Box>
                                <Box pt={4} display="flex" flexDirection={'column'} flexWrap="wrap" justifyContent="center">
                                    <CustomText variant='subtitle' style={{textAlign: 'center'}}>
                                        100 K+
                                    </CustomText>
                                    <CustomText variant='bodySmall' style={{textAlign: 'center'}}>
                                        Descargas
                                    </CustomText>
                                </Box>
                            </Box>
                            
                            <Box pt={4} display="flex" flexDirection={'row'} flexWrap="wrap" justifyContent="center" style={{gap: '16px'}}>
                                <Link
                                    href={downloadAppDynamicLink.android}
                                    target="_blank"
                                    style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}
                                >
                                    <img
                                        src={"./images/download/playstore.png"}
                                        alt="Google Play Store"
                                        className={classes.logo}
                                    />
                                </Link>
                            </Box>
                        </div>
                        <div style={{width: '50%', borderLeft: '1px solid #E5E5E5'}}>
                            <Box display="flex" flexDirection={'row'} flexWrap="wrap" justifyContent="center" style={{gap: '16px'}}>
                                    
                                    <Box pt={4} display="flex" flexDirection={'column'} flexWrap="wrap" justifyContent="center">
                                        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', gap: '16px'}}> 
                                            <CustomText variant='subtitle' style={{textAlign: 'center'}}>
                                                4.7
                                            </CustomText>
                                            <FaStar/>
                                        </div>
                                        <CustomText variant='bodySmall' style={{textAlign: 'center'}}>
                                            4.3 K opiniones
                                        </CustomText>
                                    </Box>
                                    
                                    <Box pt={4} display="flex" flexDirection={'column'} flexWrap="wrap" justifyContent="center">
                                        <CustomText variant='subtitle' style={{textAlign: 'center'}}>
                                            #99
                                        </CustomText>
                                        <CustomText variant='bodySmall' style={{textAlign: 'center'}}>
                                            En finanzas
                                        </CustomText>
                                    </Box>
                                    
                                </Box>
                                <Box pt={4} display="flex" flexWrap="wrap" justifyContent="center">
                                    <Link
                                        href={downloadAppDynamicLink.ios}
                                        target="_blank"
                                    >
                                        <img
                                            src={"./images/download/appstore.png"}
                                            alt="App Store"
                                            className={classes.logo}
                                        />
                                    </Link>
                                </Box>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

ReferrerLandingTemplate.propTypes = {
    referralDiscount: PropTypes.number,  // A number representing the discount amount
    onStartRequest: PropTypes.func,    // A function to handle the start request action
};


const styles = {
    container: {
        paddingRight: '16px',
        paddingLeft: '16px',
        paddingTop: '40px',
        paddingBottom: '40px',
    },
    hero: {
        backgroundColor: '#ffffff',
        marginBottom: '48px',
        marginTop: '32px',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
    },
    section: {
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column',
        gap: '40px',
        alignItems: 'center',
        borderRadius: '16px',
        backgroundColor: '#000',
        padding: '32px 16px 24px 16px',
    },
    heroText: {
        color: '#fff',
        textAlign: 'center',
    },
    subSection: {
        padding: '0px 16px 16px 16px',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
    },
    subSectionText: {
        textAlign: 'center',
    },
    iconWrapper: {
        backgroundColor: '#fff',
        border: '2px solid #D7AD05',
        borderRadius: '50%',
        width: '24px',
        height: '24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    icon: {
        color: '#D7AD05',
        fontSize: '18px',
    },
};

export default ReferrerLandingTemplate;